import i18n from '@/helpers/i18n';

export default [
  {
    _name: 'CSidebarNav',
    _children: [ 
      {
        _name: 'CSidebarNavTitle',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('Routes'),
        to: `/${i18n.locale}/routes/list`,
        icon: 'cil-pin',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('products'),
        to: `/${i18n.locale}/products/list`,
        icon: 'cibCodesandbox',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('pois'),
        to: `/${i18n.locale}/pois/list`,
        icon: 'cil-pin',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('events'),
        to: `/${i18n.locale}/events/list`,
        icon: 'cil-pin',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('news'),
        to: `/${i18n.locale}/news/list`,
        icon: 'cil-newspaper',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('categories'),
        to: `/${i18n.locale}/categories/list`,
        icon: 'cilTags',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('orders'),
        to: `/${i18n.locale}/orders/list`,
        icon: 'cil-money',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('reservations'),
        to: `/${i18n.locale}/reservations/list`,
        icon: 'cil-pin',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('hero'),
        to: `/${i18n.locale}/hero/list`,
        icon: 'cil-library',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('gallery'),
        to: `/${i18n.locale}/gallery/list`,
        icon: 'cilCamera',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('faqs'),
        to: `/${i18n.locale}/faqs/list`,
        icon: 'cil-info',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('pages'),
        to: `/${i18n.locale}/pages/list`,
        icon: 'cil-file',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('logout'),
        to: `/logout`,
        icon: 'cil-power-standby'
      },
      {
        _name: 'CSidebarNavTitle',
      }
    ]
  }
]